export default "__VITE_ASSET__BZazuKtM__"